import React, { useCallback, useMemo, useState } from 'react'
import { debounce } from 'lodash'
import {
  StyledSlider,
  SliderMarkContainer,
  SLIDER_READING_MIN_SEPARATION,
} from './styled'

const RangeSlider = ({
  masteryRange,
  setMasteryRange,
  sliderStyles,
  markStyles,
}) => {
  const [currentMasteryRange, setCurrentMasteryRange] = useState(masteryRange)

  const updateMasteryRange = useCallback((newMasteryRange) => {
    setCurrentMasteryRange(newMasteryRange)
    // Delay the mastery change update to reduce the number of rerenders of the page.
    debounce(setMasteryRange, 500)(newMasteryRange)
  }, [])

  const marks = useMemo(() => {
    const separation = currentMasteryRange[1] - currentMasteryRange[0]

    if (separation >= SLIDER_READING_MIN_SEPARATION) {
      return {
        [currentMasteryRange[0]]: (
          <SliderMarkContainer markStyles={markStyles}>
            {currentMasteryRange[0]}%
          </SliderMarkContainer>
        ),
        [currentMasteryRange[1]]: (
          <SliderMarkContainer markStyles={markStyles}>
            {currentMasteryRange[1]}%
          </SliderMarkContainer>
        ),
      }
    }

    const averageValue = (currentMasteryRange[1] + currentMasteryRange[0]) / 2

    let lowerTickPosition = averageValue - SLIDER_READING_MIN_SEPARATION / 2
    let upperTickPosition = averageValue + SLIDER_READING_MIN_SEPARATION / 2

    if (lowerTickPosition < 0) {
      upperTickPosition -= lowerTickPosition
      lowerTickPosition = 0
    } else if (upperTickPosition > 100) {
      lowerTickPosition -= upperTickPosition - 100
      upperTickPosition = 100
    }

    return {
      [lowerTickPosition]: (
        <SliderMarkContainer markStyles={markStyles}>
          {currentMasteryRange[0]}%
        </SliderMarkContainer>
      ),
      [upperTickPosition]: (
        <SliderMarkContainer markStyles={markStyles}>
          {currentMasteryRange[1]}%
        </SliderMarkContainer>
      ),
    }
  }, [currentMasteryRange, markStyles])

  return (
    <StyledSlider
      range
      value={currentMasteryRange}
      onChange={updateMasteryRange}
      min={0}
      max={100}
      marks={marks}
      open={false}
      sliderStyles={sliderStyles}
    />
  )
}

export default RangeSlider
